module.exports = __webpack_public_path__ + "media/images/plans/propose_restaurant/hall-img-century-court-b9a06de3993c11e83e6753c2d2e9e3ab.png";